import { createApi } from "@reduxjs/toolkit/query/react";
import MAIN_PATHS from "src/business.InterfaceLayer/store/mainPaths";
import baseQueryWithReAuth from "src/business.InterfaceLayer/store/services/utils.service/baseQueryWithReAuth";
import loyaltyProgramApiGetQueries from "./endpoints/GET";
import loyaltyProgramApiPostQueries from "./endpoints/POST";

export const loyaltyProgramApi = createApi({
	baseQuery: baseQueryWithReAuth,
	reducerPath: `${MAIN_PATHS.LOYALTY_PROGRAM}Api`,
	tagTypes: [`${MAIN_PATHS.LOYALTY_PROGRAM}TAG`],
	endpoints: (build) => ({
		...loyaltyProgramApiGetQueries(build),
		...loyaltyProgramApiPostQueries(build),
	}),
});

export const {
	useGetMyLevelQuery,
	useGetMyReferralSystemQuery,
	useGetMyTransactionsQuery,
	useSetPromoCodeMutation,
	useCheckReferralCodeMutation,
} = loyaltyProgramApi;
